export const initSecondaryNavigation = ({ withHistoryBack = true } = {}) => {
  const node = document.getElementById('secondary-navigation');
  if (!node) return;
  node.addEventListener('click', () => {
    if (withHistoryBack && document.referrer && document.referrer.includes(window.location.host)) {
      window.history.back();
    } else {
      window.location.href = node.dataset.href;
    }
  });
};
